import React from "react";
import * as childs from "./childs";
import { useWatchState } from "@/store";

function View() {

    const [[modal = {}]] = useWatchState(["modal"]);

    return Object.keys(modal).map(key => {
        const Modal = childs[key];
        if (!Modal) throw new Error("没有找到“" + key + "”弹窗！");
        return <Modal key={key} />
    })
}

export default View;